var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__content"},[_c('p',[_vm._v(_vm._s(this.modalMessage))]),_c('button',{on:{"click":_vm.closeModal}},[_vm._v("أغلق")])])])}
var staticRenderFns = []

export { render, staticRenderFns }